import React from 'react';
import './ConfirmationDialog.css';

interface ConfirmationDialogProps {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}) => {
  return (
    <div className="confirmation-dialog-overlay">
      <div className="confirmation-dialog">
        <h2 className="confirmation-dialog-title">{title}</h2>
        <p className="confirmation-dialog-message">{message}</p>
        <div className="confirmation-dialog-actions">
          <button 
            className="confirmation-dialog-button cancel-button"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className="confirmation-dialog-button confirm-button"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;